import React from 'react';
import AdminTemplate from 'components/templates/AdminTemplate';
import IMAdjustmentList from 'components/organisms/IMAdjustmentList';
import { Grid, Typography } from '@material-ui/core';
export default function IMAdjustment() {
  return (
    <AdminTemplate>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12} sm={12} style={{ marginBottom: 10 }}>
          <Typography variant="h5" component="h1" align="center">
            Gestión de Ajustes
          </Typography>
        </Grid>
      </Grid>
      <IMAdjustmentList />
    </AdminTemplate>
  );
}
